<template>

    <section>
        <div style="text-align:center; padding-top:50px;">
            <p style="color: grey;">© 2026 Trueleey.com - All rights reserved</p>
        </div>
    </section>

</template>
